import React from 'react';
import { SignoutCallbackComponent } from 'redux-oidc';

import { useSelector } from 'react-redux';
import { UserPasswordlessManager } from 'shared/oidc/passwordLessUserManager';
import { useLocation, useNavigate } from 'react-router-dom';
import { PagePath } from 'shared/constants/pagePath';
import { getApplicationRootPath } from 'shared/utils/NavigationHelper';
import { PlantItemConstants } from 'plantItemNew/constants/plantItemConstants';
import { PlantItemRenewalConstants } from 'plantItemRenewal/constants/plantItemRenewalConstants';

export const Logout = (props) => {
  const form = useSelector((state) => state.form);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const cancelLogin = queryParams.get('cancelLogin');

  const navigateToLandingPage = (rootPath) => {
    switch (rootPath) {
      case PagePath.plantItemNewRoot:
        window.location.href = PlantItemConstants.snswLandingPageUrl;
        return;
      case PagePath.plantDesignRoot:
        navigate(PagePath.plantDesignWhatYouNeed);
        return;
      case PagePath.plantItemRenewalRoot:
        window.location.href = PlantItemRenewalConstants.snswLandingPageUrl;
        return;
      default:
        window.location.href = PlantItemConstants.snswLandingPageUrl;
    }
  };

  return (
    <SignoutCallbackComponent
      userManager={UserPasswordlessManager.instance()}
      successCallback={(_) => {
        if (cancelLogin) {
          if (form.redirectTo.startsWith(PagePath.timeout)) {
            navigate(form.redirectTo);
          } else {
            const lastVisitedRootPath = getApplicationRootPath(form?.redirectTo, PagePath.plantItemNewRoot);
            navigateToLandingPage(lastVisitedRootPath);
          }
        } else {
          navigate(form.redirectTo);
        }
      }}
      errorCallback={console.error}
    >
      <div>Logging out...</div>
    </SignoutCallbackComponent>
  );
};
